"use client";

import { useState } from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { Home, Search, ReceiptText, UserRound, Headset, X } from "lucide-react";
import { getAppStoreUrl } from "@/lib/app-store";
import { trackAction } from "@/lib/track-action";

const tabs = [
  { label: "Calii", href: "/", icon: Home },
  { label: "Buscar", href: "/ver-categorias", icon: Search },
  { label: "Pedidos", href: "/pedidos", icon: ReceiptText },
  { label: "Soporte", href: "/soporte", icon: Headset },
  { label: "Cuenta", href: "/cuenta", icon: UserRound },
];

const allowedPrefixes = ["/", "/categorias", "/cuenta", "/pedidos", "/ver-categorias", "/soporte"];

function isAllowedRoute(pathname: string) {
  if (pathname === "/") return true;
  return allowedPrefixes.some(
    (prefix) => prefix !== "/" && pathname.startsWith(prefix)
  );
}

function isActive(tabHref: string, pathname: string) {
  if (tabHref === "/") return pathname === "/";
  return pathname.startsWith(tabHref);
}

export default function BottomTabBar() {
  const pathname = usePathname();
  const [bannerDismissed, setBannerDismissed] = useState(false);

  if (!isAllowedRoute(pathname)) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 md:hidden">
      {!bannerDismissed && (
        <a
          href={getAppStoreUrl()}
          target="_blank"
          rel="noopener noreferrer"
          className="w-full bg-[#232428] text-[#E3C425] flex items-center gap-2 px-4 py-2.5"
          onClick={() => trackAction("DOWNLOAD-BANNER-CLICK", getAppStoreUrl())}
        >
          <div className="flex flex-col flex-1 min-w-0">
            <span className="text-xs text-white/90 mt-0.5 cursor-pointer">Descarga la app &rsaquo;</span>
          </div>
          <button
            type="button"
            onClick={(e) => { e.preventDefault(); e.stopPropagation(); trackAction("APP-BANNER-DISMISSED"); setBannerDismissed(true); }}
            className="shrink-0 text-white/90 cursor-pointer"
            aria-label="Cerrar"
          >
            <X className="h-4 w-4" />
          </button>
        </a>
      )}
      <nav className="border-t border-gray-300 bg-white pb-[env(safe-area-inset-bottom)]">
        <div className="flex">
          {tabs.map((tab) => {
            const active = isActive(tab.href, pathname);
            return (
              <Link
                key={tab.href}
                href={tab.href}
                className={`flex flex-1 flex-col items-center gap-0.5 py-3 text-xs ${
                  active ? "text-teal-500" : "text-gray-500"
                }`}
              >
                <tab.icon className="h-4 w-4 mb-1" />
                <span className="text-xs">{tab.label}</span>
              </Link>
            );
          })}
        </div>
      </nav>
    </div>
  );
}
